import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetAppointmentNotification } from "../../store/notification/notificationActions";
import { getAllWithdraw, getWithdrawList } from "../../store/wallet/walletActions";
import { WithdrawRequest } from './widthdrawRequest';
import { WithdrawList } from './withdrawList';

const Withdraw = () => {
    const { currentProfile } = useSelector(state => state.profile)
    const [isRequest, setIsRequest] = useState(false);
    const [nodes, setNodes] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        initView()
    }, [])

    const initView = () => {
        if (currentProfile.role == 1) {
            dispatch(getAllWithdraw())
                .unwrap()
                .then((v) => setNodes(v))
        } else {

            dispatch(getWithdrawList())
                .unwrap()
                .then((v) => setNodes(v))
        }
        dispatch(resetAppointmentNotification())
    }
    
    return (
        <section className="w-full">
            <div className="bg-white/70 rounded-2xl p-3 sm:p-4 mb-4 border border-nt-blue/10">
                <div className="flex justify-end gap-2 bg-white p-1 rounded-xl border border-nt-blue/10">
                    <button
                        type="button"
                        onClick={() => setIsRequest(false)}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                            !isRequest ? "bg-nt-blue text-white" : "text-nt-blue hover:bg-nt-grey/20"
                        }`}
                    >
                        Request History
                    </button>
                    <button
                        type="button"
                        onClick={() => setIsRequest(true)}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                            isRequest ? "bg-nt-blue text-white" : "text-nt-blue hover:bg-nt-grey/20"
                        }`}
                    >
                        New Withdrawal
                    </button>
                </div>
            </div>

            {!isRequest ? (
                <WithdrawList
                    setIsRequest={setIsRequest}
                    initView={initView}
                    nodes={nodes}
                    setNodes={setNodes}
                />
            ) : (
                <WithdrawRequest initView={initView} setIsRequest={setIsRequest} />
            )}
        </section>
    )
}

export { Withdraw }